module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.envColor),
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menuHeaderWrapper col-lg-7 col-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "linksWrapper  mobileNot"
  }, [_c('router-link', {
    attrs: {
      "tag": "div",
      "to": "/",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.homeLink'))
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "homeId"
    }
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.homeLink")))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "div",
      "to": "/catalog"
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.catalogueLink'))
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "catalogId"
    }
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.catalogueLink")))])]), _vm._v(" "), (_vm.hasAccessRead('plano_builder')) ? _c('router-link', {
    attrs: {
      "tag": "div",
      "to": '/planos?campaign=' + _vm.currentCampaignId
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.planoLink'))
      }
    }
  }, [_c('a', [_vm._v(" " + _vm._s(_vm.$t("menuHeader.planoLink")))])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessRead('orders_manager') && false) ? _c('router-link', {
    attrs: {
      "tag": "div",
      "to": "/list-orders"
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', 'order manager')
      }
    }
  }, [_c('a', [_vm._v("ORDERS")])]) : _vm._e(), _vm._v(" "), (_vm.canAccessLaunchForecast) ? _c('router-link', {
    attrs: {
      "tag": "div",
      "to": _vm.forecastRoutes.BASE
    },
    nativeOn: {
      "click": function($event) {
        _vm.forecastSetIsShowActiveOnly(false);
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.forecastLink'));
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("menuHeader.forecastLink")))])]) : _vm._e(), _vm._v(" "), (_vm.canAccessCatalogForecast) ? _c('router-link', {
    attrs: {
      "tag": "div",
      "to": _vm.catalogForecastLink
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.catalogForecastLink'))
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("menuHeader.catalogForecastLink")))])]) : _vm._e(), _vm._v(" "), (_vm.canAccessTools) ? _c('div', {
    staticClass: "dropdown",
    class: _vm.isToolsLink() ? 'router-link-active' : ''
  }, [_c('a', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.tools.name")))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content d-none"
  }, [(_vm.canAccessToolsUsers) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": '/users/user-list'
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.tools.manageUsers'))
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("menuHeader.tools.manageUsers")) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.canAccessToolsZones) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": '/zones/zone-list'
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.tools.manageZones'))
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("menuHeader.tools.manageZones")) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.canAccessToolsCampaigns) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": '/campaigns/campaign-list'
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.tools.manageCampaigns'))
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("menuHeader.tools.manageCampaigns")) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.canAccessToolsExportExcel) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": '/exportExcel'
    },
    nativeOn: {
      "click": function($event) {
        _vm.trackEventMatomo('trackEvent', 'Menu header', 'link', _vm.$t('menuHeader.tools.exportExcel'))
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("menuHeader.tools.exportExcel")) + "\n                        ")]) : _vm._e()], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mobileMenuWrapper mobileOnly tabletNot"
  }, [_c('div', {
    staticClass: "mobileOnly mobileMenu",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("menuHeader.menu")))])]), _vm._v(" "), _c('nav', {
    staticClass: "cbp-spmenu cbp-spmenu-vertical cbp-spmenu-left menuOff",
    class: {
      menuOn: _vm.menuMobile
    },
    attrs: {
      "id": "cbp-spmenu-s1 mobileOnly"
    }
  }, [_c('p', {
    staticClass: "abs pointer",
    attrs: {
      "id": "closeMenu"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "linkContent"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('span', {
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.homeLink")))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/catalog",
      "exact": ""
    }
  }, [_c('span', {
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.catalogueLink")))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/planos?campaign=' + _vm.currentCampaignId,
      "exact": ""
    }
  }, [_c('span', {
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.planoLink")))])])], 1), _vm._v(" "), _c('selector-lang', {
    attrs: {
      "mobilemenu": "true",
      "classescss": "select"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentBrandId),
      expression: "currentBrandId"
    }],
    staticClass: "ff-light uppercase",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentBrandId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.saveBrand]
    }
  }, [_c('option', {
    staticClass: "uppercase",
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.selectBrand")))]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      key: brand.id,
      staticClass: "uppercase",
      domProps: {
        "value": brand.id
      }
    }, [_vm._v(_vm._s(brand.name) + " ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentZone),
      expression: "currentZone"
    }],
    staticClass: "ff-light uppercase",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentZone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.saveZone]
    }
  }, [_c('option', {
    staticClass: "uppercase",
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.selectZone")))]), _vm._v(" "), _vm._l((_vm.zones), function(zone) {
    return _c('option', {
      key: zone.id,
      staticClass: "uppercase",
      domProps: {
        "value": zone.id
      }
    }, [_vm._v(_vm._s(zone.name) + " ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentCampaignId),
      expression: "currentCampaignId"
    }],
    staticClass: "ff-light uppercase",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentCampaignId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectCampaign]
    }
  }, [(_vm.currentCampaignId == '0') ? _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v(_vm._s(_vm.$t("catalogue.allCampaign")) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
    return _c('option', {
      key: campaign.id,
      staticClass: "uppercase",
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name) + "\n                            ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "user mobileOnly flexContainer fd-r cf"
  }, [_c('div', {
    staticClass: "pastille flexContainer fd-r ai-c ac-c"
  }, [_c('div', {
    staticClass: "textWrapper center"
  }, [_vm._v(_vm._s(_vm.rem3rchUser.user.initial))])]), _vm._v(" "), _c('div', {
    staticClass: "arrowUser fright"
  }, [(_vm.displayArrowUp) ? _c('a', {
    staticClass: "arrowLight fright pointer",
    on: {
      "click": function($event) {
        _vm.showArrow()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chev_up_light.png"),
      "width": "14",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.displayArrowDown) ? _c('a', {
    staticClass: "arrowLight fright pointer",
    on: {
      "click": _vm.showArrow
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chev_down_light.png"),
      "width": "14",
      "alt": ""
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.displayArrowDown) ? _c('ul', {
    staticClass: "abs deco"
  }, [_c('li', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: ('preferencesModal'),
      expression: "'preferencesModal'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.openModalPreferences('preferencesModal')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("common.preferences")) + "\n                    ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "setUserInfo",
      rawName: "v-setUserInfo.logout",
      modifiers: {
        "logout": true
      }
    }],
    staticClass: "pointer"
  }, [_vm._v(_vm._s(_vm.$t("common.deconnexion")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "userWrapper col-lg-5 col-md-6 mobileNot"
  }, [_c('BasketMenu'), _vm._v(" "), _c('div', {
    staticClass: "dropdown itemMenuContainer"
  }, [_c('button', {
    staticClass: "myPDF btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "id": "dropdownMenu1",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.openList()
      }
    }
  }, [_vm._v("\n                    MY BOOK PDF\n                ")]), _vm._v(" "), (_vm.openLists === true) ? _c('ul', {
    staticClass: "abs ulDropdown",
    attrs: {
      "aria-labelledby": "dropdownMenu1"
    }
  }, [_c('li', {
    staticClass: "liDropdown",
    on: {
      "click": function($event) {
        _vm.openBook('export')
      }
    }
  }, [_c('a', [_vm._v("All books")])]), _vm._v(" "), _vm._l((_vm.getWishList), function(n, index) {
    return _c('li', {
      key: n.id,
      staticClass: "liDropdown",
      on: {
        "click": function($event) {
          _vm.openBook(index)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(n.name))])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "ml-2 mr-4 help-link",
    attrs: {
      "to": "/help",
      "exact": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("menuHeader.help")))])]), _vm._v(" "), _c('selector-lang', {
    staticStyle: {
      "margin-top": "3px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user rel"
  }, [_c('div', {
    staticClass: "pastille flexContainer fd-r ai-c ac-c cf"
  }, [_c('div', {
    staticClass: "textWrapper initial"
  }, [_vm._v(_vm._s(_vm.rem3rchUser.user.initial))]), _vm._v(" "), _c('div', {
    staticClass: "arrowUser fright"
  }, [(_vm.displayArrowUp) ? _c('a', {
    staticClass: "arrowLight fright pointer",
    on: {
      "click": _vm.showArrow
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chev_up_light.png"),
      "width": "14",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.displayArrowDown) ? _c('a', {
    staticClass: "arrowLight fright pointer",
    on: {
      "click": _vm.showArrow
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chev_down_light.png"),
      "width": "14",
      "alt": ""
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.displayArrowDown) ? _c('ul', {
    staticClass: "abs deco"
  }, [_c('li', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: ('preferencesModal'),
      expression: "'preferencesModal'"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.openModalPreferences('preferencesModal')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("common.preferences")) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.openModalAbonnement
    }
  }, [_vm._v(_vm._s(_vm.$t("abonnement.title")))]), _vm._v(" "), (
    _vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER, _vm.APPLICATION.FORECAST_ID) ||
    _vm.hasAccessByProfile(_vm.PROFILES.ZONES_SUPERVISOR, _vm.APPLICATION.FORECAST_ID) ||
    _vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER, _vm.APPLICATION.CATALOG_FORECAST_ID) ||
    _vm.hasAccessByProfile(_vm.PROFILES.ZONES_SUPERVISOR, _vm.APPLICATION.CATALOG_FORECAST_ID)
  ) ? _c('li', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('label', {
    staticClass: "switch",
    attrs: {
      "for": "switchGod"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.godMode),
      expression: "godMode"
    }],
    attrs: {
      "type": "checkbox",
      "id": "switchGod"
    },
    domProps: {
      "checked": Array.isArray(_vm.godMode) ? _vm._i(_vm.godMode, null) > -1 : (_vm.godMode)
    },
    on: {
      "change": function($event) {
        _vm.activeGodMode()
      },
      "__c": function($event) {
        var $$a = _vm.godMode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.godMode = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.godMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.godMode = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t("menuHeader.godMode")))])])]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "setUserInfo",
      rawName: "v-setUserInfo.logout",
      modifiers: {
        "logout": true
      }
    }],
    staticClass: "pointer"
  }, [_vm._v(_vm._s(_vm.$t("common.deconnexion")))])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.modalBook) ? _c('modalBook', {
    on: {
      "hideBookModal": function($event) {
        _vm.modalClose($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDisplay) ? _c('WishList') : _vm._e(), _vm._v(" "), (!_vm.isHidden) ? _c('Preferences', {
    attrs: {
      "action": _vm.dataAction
    },
    on: {
      "close": function($event) {
        _vm.isHidden = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.abonnement) ? _c('Abonnement', {
    on: {
      "hideAbonnementModal": function($event) {
        _vm.modalClose($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.godMode) ? _c('div', {
    staticClass: "godMode"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.godModeModal) ? _c('GodModeModal', {
    on: {
      "closed": function($event) {
        _vm.reloadGodMode()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logoRem3rch"
    }
  }, [_c('div', {
    staticClass: "logo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-god"
  }, [_c('span', [_vm._v("\n                God "), _c('br'), _vm._v("\n                Mode\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02fe9318","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/MenuHeader.vue
// module id = 2982
// module chunks = 0